// @module TavanoTeam.CSExtensions.CSCertCaptureExt.List.View
define('TavanoTeam.CSExtensions.CSCertCaptureExt.List.View'
,	[
		'TavanoTeam.CSExtensions.CSCertCaptureExt.List.Cell.View'
	,	'TavanoTeam.CSExtensions.CSCertCapture.Model'
	,	'TavanoTeam.CSExtensions.CSCertCaptureExt.CertPDF.View'

	,	'ListHeader.View'
	,	'GlobalViews.Pagination.View'
	,	'GlobalViews.ShowingCurrent.View'
	,	'AjaxRequestsKiller'

	,	'tavanoteam_csextensions_cscertcaptureext_list.tpl'

	,	'SC.Configuration'
	,	'Utils'
	,	'Backbone'
	,	'Backbone.CollectionView'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		CertCaptureListCellView
	,	CertCaptureModel
	,	CertCapturePDFView

	,	ListHeaderView
	,	GlobalViewsPaginationView
	,	GlobalViewsShowingCurrentView
	,	AjaxRequestsKiller

	,	tavanoteam_csextensions_cscertcaptureext_list_tpl

	,	Configuration	
	,	Utils
	,	Backbone
	,	BackboneCollectionView
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class TavanoTeam.CSExtensions.CSCertCaptureExt.List.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_csextensions_cscertcaptureext_list_tpl

	,	title: Utils.translate('Certificates List')

	,	className: 'CertificatesListView'

	,	page_header: Utils.translate('Certificates List')

	,	initialize: function (options) 
		{

			this.options = options;
			this.application = options.application;
			this.collection = options.collection;

			this.listenCollection();

			this.collection.on('reset', this.render, this);

			this.ListHeader = new ListHeaderView({
				view: this
			,	application: this.application
			,	collection: this.collection
			,	filters: this.filterOptions
			,	hidePagination: true
			});
		}

	,	events:
		{
			'click [data-action="cert-view-file"]': 'certPDFFile'
		}

	,	filterOptions: 
		[
			{
				value: "PENDING,EXPIRED,COMPLETE"
			,	name: Utils.translate('Show All Certificate Status')
			,	selected: true
			}
		,	{
				value: "COMPLETE"
			,	name: Utils.translate('Approved Certificates')
			}
		,	{
				value: "PENDING"
			,	name: Utils.translate('Pending Certificates')
			}
		,	{
				value: "EXPIRED"
			,	name: Utils.translate('Expired Certificates')
			}
		]

	, 	childViews: 
		{
			'TaxExemptCert.Collection': function()
			{
				var self = this
				,	cert_collection = new Backbone.Collection(
					this.collection.map(function (cert)
					{
						var dateC = new Date(cert.get('created'))
						,	yearC = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dateC)
						,	monthC = new Intl.DateTimeFormat('en', { month: 'short' }).format(dateC)
						,	dayC = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(dateC)
						,	dateE = new Date(cert.get('expiration_date'))
						,	yearE = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dateE)
						,	monthE = new Intl.DateTimeFormat('en', { month: 'short' }).format(dateE)
						,	dayE = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(dateE);

						return new Backbone.Model({
							touchpoint: 'customercenter'
						,	internalid: cert.get('id')
						,	filename: cert.get('filename')
						,	status: cert.get('status').name
						,	columns: [
								{
									label: Utils.translate('State')
								,	type: 'cert-state'
								,	name: 'cert-state'
								,	value: cert.get('exposure_zone').name
								}
							,	{
									label: Utils.translate('Date Created')
								,	type: 'cert-date-created'
								,	name: 'cert-date-created'
								,	value: monthC + '-' + dayC + '-' + yearC
								}
							,	{
									label: Utils.translate('Expiration Date')
								,	type: 'cert-expiration-date'
								,	name: 'cert-expiration-date'
								,	value: monthE + '-' + dayE + '-' + yearE
								}
							,	{
									label: Utils.translate('Status')
								,	type: 'cert-status'
								,	name: 'cert-status'
								,	value: cert.get('status').name
								}
							]
						})
					}));

					return new BackboneCollectionView({
						childView: CertCaptureListCellView
					,	collection: cert_collection
					,	viewsPerRow: 1
					});
			}
		,	'GlobalViews.Pagination': function()
			{
				return new GlobalViewsPaginationView(
					_.extend(
						{
							totalPages: Math.ceil(
								this.collection.totalRecordsFound / this.collection.recordsPerPage
							)
						},
						Configuration.defaultPaginationSettings
					)
				)
			}
		,	'GlobalViews.ShowCurrentPage': function()
			{
				return new GlobalViewsShowingCurrentView({
					items_per_page: this.collection.recordsPerPage
				,	total_items: this.collection.totalRecordsFound
				,	total_pages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage)
				});
			}
		,	"ListHeader": function()
			{
				return this.ListHeader;
			}
		}

	,	listenCollection: function()
		{
			this.setLoading(true);

			this.collection.on({
				request: jQuery.proxy(this, 'setLoading', true),
            	reset: jQuery.proxy(this, 'setLoading', false)
			});
		}

	,	setLoading: function(value)
		{
			this.isLoading = value;
		}

	,	certPDFFile: function(e)
		{
			e.preventDefault();

			var fileId = jQuery(e.target).data('id')
			,	certModel = new CertCaptureModel()
			,	self = this;

			certModel.fetch({
				data: {
					certId: fileId
				}
			,   killerId: AjaxRequestsKiller.getKillerId()
			})
			.done(function(result)
			{
				var pdfEncoded = result.pdfFile
				,	pdfView = new CertCapturePDFView({
					application: self.options.application
				,	encodedPDFStr: pdfEncoded
				});

				self.options.application.getLayout().showInModal(pdfView);
			});
		}

		//@method getContext @return TavanoTeam.CSExtensions.CSCertCaptureExt.List.View.Context
	,	getContext: function getContext()
		{
			//@class TavanoTeam.CSExtensions.CSCertCaptureExt.List.View.Context
			return {
				pageHeader: this.page_header
			,	showBackToAccount: Configuration.get('siteSettings.sitetype') === 'STANDARD'
			,	showPagination: !!(this.collection.totalRecordsFound && this.collection.recordsPerPage)
			,	isLoading: this.isLoading
			,	collectionLengthGreaterThan0: this.collection.totalRecordsFound > 0
			};
		}
	});
});
